import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { HTMLTrans } from '../Common/Translations';

function FormattedCounter(props) {
  return <div className="timer__container">
    <div className="title"><i className="fa fa-clock-o"></i><HTMLTrans id="promotion.promotionscounter_timer_title">SALES END IN</HTMLTrans></div>
    <div className="timer-countdown">
      <em>{props.counter.d}</em>
      <em>{props.counter.h}</em>
      <em>{props.counter.m}</em>
      <em>{props.counter.s}</em>
      <div className="timer-label">
        <HTMLTrans id="promotion.promotionscounter_timer_label"><i>days</i><i>hrs</i><i>mins</i><i>secs</i></HTMLTrans>
      </div>
    </div>
  </div>;
}

function FormattedCounterV2(props) {
  let day = props.counter.d > 1 ? 'days' : 'day';
  let counter =`${props.counter.d} ${day}: ${props.counter.h}: ${props.counter.m}: ${props.counter.s}`;

  return <RenderFormattedCounterV2 counter={counter}/>;
}

export const RenderFormattedCounterV2 = (props) => (
  <div className="counter__container col-12 p-0 mt-2">
    <i className="fa fa-clock-o fa-lg" aria-hidden="true"></i>
    <span className="ml-2"><HTMLTrans id='promotion.sales_ends'>Sales Ends</HTMLTrans></span>
    <b className="ml-1">{props.counter}</b>
  </div>
);

function MobileFormatCounter(props) {
  return <div>
      <em>{props.counter.d}</em> :
      <em>{props.counter.h}</em> :
      <em>{props.counter.m}</em> :
      <em>{props.counter.s}</em>
    </div>;
}

export function getCounter(counter, dateNow, callback = () => null) {
  const dates = [];
  let d;
  counter.map(function (date) {
    d = date.replace(/-/g, '/');
    if (new Date(d).getTime() - dateNow > 0) {
      dates.push(d);
      callback(d);
    }
  }, this);
  return dates[0];
}

export default class PromotionsCounter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateNow: '',
      dateEnd: '',
      counter: {},
    };
  }

  componentDidMount() {
    const timestampArray = this.props.timestamp.split(' ');
    const counter = this.props.counter.replace(/[[\]'"]/g, '').split(','); // remove square brackets and double quotes
    // const counter = ['2018-08-17 18:23:00', '2018-08-17 18:23:10', '2018-08-17 18:59:20']; // example

    this.counter = counter;
    this.timeLeft = {
      d: '00', h: '00', m: '00', s: '00',
    };
    this.sec = 0;
    this.index = 0;
    this.counterArray = [];
    this.counterArray.push((`${timestampArray[0]} ${timestampArray[1]}`).replace(/-/g, '/'));

    this.setState({ dateNow: new Date(this.counterArray[this.index]) }, () => this.start());
  }

  addToCounterArray(date) {
    this.counterArray.push(date);
  }

  start() {
    this.setState({ counter: this.timeLeft });
    this.setState({ dateNow: new Date(this.counterArray[this.index]) });

    const timer = getCounter(
      this.counter,
      new Date(this.state.dateNow).getTime(),
      date => this.addToCounterArray(date),
    );
    if (timer) {
      this.setState({ dateEnd: timer });
      this.timerID = setInterval(() => this.tick(), 1000);
    } else {
      this.props.onExpired();
    }
    this.index += 1;
  }

  tick() {
    const secs = (new Date(this.state.dateEnd).getTime() / 1000) - Math.floor(new Date(this.state.dateNow).getTime() / 1000) - this.sec - 1;

    if (secs >= 0) {
      const strD = Math.floor(secs / 86400) % 36500;
      const strH = Math.floor(secs / 3600) % 24;
      const strM = Math.floor(secs / 60) % 60;
      const strS = secs % 60;
      this.timeLeft.d = this.leadingZero(strD);
      this.timeLeft.h = this.leadingZero(strH);
      this.timeLeft.m = this.leadingZero(strM);
      this.timeLeft.s = this.leadingZero(strS);
      this.sec += 1;
    } else {
      // End
      this.sec = 1;
      clearInterval(this.timerID);
      this.start();
    }
    this.setState({ counter: this.timeLeft });
  }

  leadingZero(num) {
    return (num < 10) ? `0${num}` : `${num}`;
  }

  render() {
    const prpPath = window.location.pathname.split('/').slice(1)[0];

    if (this.props.isMobile && prpPath !== 'prp') {
      return <MobileFormatCounter counter={this.state.counter}/>;
    } else if (this.props.counterVersion === 2) {
      return <FormattedCounterV2 counter={this.state.counter}/>;
    } else {
      return <FormattedCounter counter={this.state.counter}/>;
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }
}

PromotionsCounter.PropTypes = {
  counter: PropTypes.array.required,
  onExpired: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/Promotion/PromotionsCounter.js